import { ProgressTracking } from "@/components/ProgressTracking";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Progress2 = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-gray-50 p-8">
      <Button
        onClick={() => navigate("/")}
        variant="outline"
        className="mb-8"
      >
        Back to Home
      </Button>
      <ProgressTracking 
        familyName="Rice Family"
        googleDriveUrl="https://drive.google.com/drive/folders/1liX59yKF95tpCKbIUbPeKdRM3--MPBNY?usp=sharing"
        password="rice"
      />
    </div>
  );
};

export default Progress2;